import React from 'react'

const Manual_eliminar_clientes_dashboard_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          ¿Cómo eliminar de manera permanente clientes dentro del Dashboard de Clau.io?
        </h2>
        <iframe
          src="https://scribehow.com/embed/Como_eliminar_de_manera_permanente_clientes_dentro_del_Dashboard_de_Clauio__5mKI0MzlT-OTSp5Xh83AOA?as=scrollable"
          className="scribe-iframe-general-84"
          width="100%"
          height="3800"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_eliminar_clientes_dashboard_clau
